function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// lib imports
import React, { Suspense, useState, useMemo, useCallback, useContext } from 'react';
import { connect } from 'react-redux';
import { Box, Text, Footer, Anchor, ThemeContext } from 'grommet';
import { useRouteMatch, useParams } from 'react-router-dom';
import logo from './components/logo.png';
import PropTypes from 'prop-types';
// CORE imports
// import Sidebar from 'granite-admin/core/components/Sidebar';
import Loader from 'granite-admin/core/components/Loader';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import useUtility from 'granite-admin/utils/useUtility';

// application imports
import Alerts from './components/Alerts';
import DashboardHeader from './components/DashboardHeader';
import ViewUrlLayer from './components/ViewUrlLayer';
import NotFoundPage from 'granite-admin/core/components/NotFoundPage';
// import PageHeading from 'granite-admin/core/components/PageHeading';
import ErrorBoundary from './components/ErrorBoundary';
import ImageView from 'granite-admin/core/components/ImageView';
import Notes from 'granite-admin/core/components/Notes';
import Documents from 'granite-admin/core/components/Documents';
import Audits from 'granite-admin/core/components/Audits';
import TaskDetail from 'granite-admin/core/components/TasksDetail';
import Tabs from 'granite-admin/core/components/Tabs';
import useWindowDimensions from 'granite-admin/utils/useWindowDimensions';
import * as PanelPermissionsDucks from 'granite-admin/common/ducks/panelPermissions';
import useRouteChange from 'granite-admin/utils/useRouteChange';
import InviteUser from '../InviteUser';
const DashboardLayout = ({
  pathname,
  history,
  breadcrumbPath,
  heading,
  addTabBtn,
  panelPermissions,
  noDivider,
  permissions,
  noSidebar,
  noHeader,
  footerLabel,
  noAlert,
  component: Component,
  tabs,
  childProps,
  noFooter,
  fields,
  entityName,
  componentMargin,
  userEmail,
  shouldFetchHelpTexts,
  shouldFetchPermissions,
  navigationLayout,
  noTopNavbar
}) => {
  const {
    path
  } = useRouteMatch();
  const [showActiveTab, setShowActiveTab] = useState(false);
  const [subPaths, setSubPaths] = useState(null);
  const [showIframeUrl, setIframeUrl] = useState(false);
  const [newFields, setNewFields] = useState(false);
  const theme = useContext(ThemeContext);
  const config = useContext(ConfigContext);
  const {
    align: sidebarPosition,
    showUserDropMenu,
    showUserProfile,
    showReferGranite,
    width: sidebarWidth,
    SideBarComponent,
    TopBarComponent,
    getItemCount
  } = config?.sidebarSettings;
  const {
    PageHeading
  } = config?.pageHeading;
  const windowDimensions = useWindowDimensions();
  const grandListner = React.useCallback(event => {
    switch (event.type) {
      case 'ADD_SUBROUTE':
        setSubPaths(oldSubs => {
          if (event.data !== path) return event.data;else return oldSubs;
        });
        break;
      case 'UNSET_ACTIVE_TAB':
        setShowActiveTab(false);
        break;
      case 'COPY_IFRAME_URL':
        setIframeUrl(userEmail);
        break;
      default:
        break;
    }
  }, [path, userEmail]);
  useUtility({
    grandListner
  });
  const tempFields = useMemo(() => {
    if (newFields?.length > 0) {
      if (fields?.length > 0) {
        return [...fields, ...newFields]; //newFields now cotain array fields from extra data
      } else {
        return newFields;
      }
    } else if (newFields === true) {
      if (fields?.length > 0) {
        return [...fields, 'docType', 'docSubType']; //newFields now cotain array fields from extra data
      } else {
        return ['docType', 'docSubType'];
      }
    }
    return fields;

    // return fields?.length > 0 ? (newFields ? [...fields, 'docType', 'docSubType'] : fields) : newFields ? ['docType', 'docSubType'] : fields;
  }, [newFields, fields]);
  const {
    isPermissionLoading: isLoading,
    hasAccess
  } = useRouteChange({
    permissions,
    fields: tempFields,
    entity_name: entityName,
    shouldFetchHelpTexts,
    shouldFetchPermissions
  });
  const params = useParams();
  const websiteURL = process.env.REACT_APP_WEBSITE_URL;
  const pagePermissions = useMemo(() => {
    let pagePermissionsArray = panelPermissions[path] ? [...panelPermissions[path]] : [];
    if (panelPermissions[subPaths]) pagePermissionsArray = [...pagePermissionsArray, ...panelPermissions[subPaths]];
    return pagePermissionsArray;
  }, [subPaths, panelPermissions, path]);
  const {
    id
  } = useParams();
  const actionItems = useMemo(() => {
    const actions = {};
    if (pagePermissions) pagePermissions.forEach(i => {
      if (['audits', 'notes', 'documents', 'tasks'].indexOf(i.type) > -1) actions[i.type] = i.extra_data;
      // eslint-disable-next-line
      i.type === 'documents' && setNewFields(i.extra_data?.fields || true);
      if (i.type === 'notes' && i?.extra_data?.isOpened && id !== 'add') {
        setShowActiveTab('notes');
      } else if (i.type === 'documents' && i?.extra_data?.isOpened && id !== 'add') {
        setShowActiveTab('documents');
      }
    });
    return actions;
  }, [id, pagePermissions]);
  const getActionProps = useCallback(action => {
    const {
      objectId,
      contentTypeName,
      contentTypeId,
      notesName,
      fields
    } = action;
    const {
      [objectId?.slice(1)]: id
    } = params;
    return {
      objectId: parseInt(id),
      contentTypeName,
      contentTypeId,
      notesName,
      fields
    };
  }, [params]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Box, {
    direction: navigationLayout === 'top_menu_bar' && windowDimensions.width > 750 ? 'column' : 'row',
    fill: true
  }, (!noSidebar && navigationLayout === 'side_menu_bar' && sidebarPosition === 'left' || !noTopNavbar && windowDimensions.width < 751 && navigationLayout === 'top_menu_bar') && /*#__PURE__*/React.createElement(SideBarComponent, {
    collapsible: true,
    pathname: pathname,
    history: history,
    sidebarPosition: sidebarPosition,
    showUserDropMenu: showUserDropMenu,
    showUserProfile: showUserProfile,
    showReferGranite: showReferGranite,
    width: sidebarWidth
  }), !noTopNavbar && windowDimensions.width > 750 && navigationLayout === 'top_menu_bar' && /*#__PURE__*/React.createElement(TopBarComponent, {
    pathname: pathname,
    history: history,
    theme: theme,
    showUserDropMenu: showUserDropMenu,
    getItemCount: getItemCount
  }), /*#__PURE__*/React.createElement(Box, {
    background: "full-screen-background-color",
    overflow: {
      vertical: 'auto'
    },
    fill: true
  }, !noAlert && config.showVerifyAccount && /*#__PURE__*/React.createElement(Alerts, null), !noHeader && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DashboardHeader, {
    history: history,
    breadcrumbPath: breadcrumbPath,
    addTabBtn: addTabBtn
  }), /*#__PURE__*/React.createElement(PageHeading, {
    noDivider: noDivider,
    heading: heading,
    breadcrumbPath: breadcrumbPath,
    permissions: pagePermissions || [],
    actionItems: actionItems,
    setShowActiveTab: setShowActiveTab
  })), /*#__PURE__*/React.createElement(Box, {
    fill: true
  }, isLoading && /*#__PURE__*/React.createElement(Box, {
    fill: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, null)), !isLoading && !hasAccess && /*#__PURE__*/React.createElement(NotFoundPage, null), !isLoading && hasAccess && /*#__PURE__*/React.createElement(Box, {
    flex: {
      grow: 1
    },
    margin: componentMargin ? {
      horizontal: 'small',
      vertical: 'xsmall'
    } : null
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Box, {
      fill: true,
      align: "center",
      justify: "center"
    }, /*#__PURE__*/React.createElement(Loader, null))
  }, tabs ? /*#__PURE__*/React.createElement(Tabs, {
    tabs: tabs
  }) : /*#__PURE__*/React.createElement(Component, childProps)))), !noFooter && /*#__PURE__*/React.createElement(Footer, {
    pad: "small",
    direction: "row",
    gap: "small",
    justify: "end"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    alignSelf: "end"
  }, /*#__PURE__*/React.createElement(Anchor
  // reverse
  // icon={<ImageView src={logo} size="27px" />}
  , {
    onClick: () => window.open(websiteURL),
    label: footerLabel || 'Powered by T2B Granite'
  })), /*#__PURE__*/React.createElement(Text, {
    alignSelf: "end"
  }, /*#__PURE__*/React.createElement(InviteUser, {
    inFooter: true
  }))), /*#__PURE__*/React.createElement(ImageView, {
    src: logo,
    size: "27px"
  })))), !noSidebar && navigationLayout === 'side_menu_bar' && sidebarPosition === 'right' && /*#__PURE__*/React.createElement(SideBarComponent, {
    collapsible: true,
    pathname: pathname,
    history: history,
    sidebarPosition: sidebarPosition,
    showUserDropMenu: showUserDropMenu,
    showUserProfile: showUserProfile,
    showReferGranite: showReferGranite,
    width: sidebarWidth
  }), showActiveTab === 'tasks' && /*#__PURE__*/React.createElement(TaskDetail, _extends({}, getActionProps(actionItems['tasks']), {
    setTaskLayer: setShowActiveTab
  })), showActiveTab === 'documents' && /*#__PURE__*/React.createElement(Documents, _extends({}, getActionProps(actionItems['documents']), {
    setShow: setShowActiveTab
  })), showActiveTab === 'notes' && /*#__PURE__*/React.createElement(Notes, _extends({}, getActionProps(actionItems['notes']), {
    setShowNotes: setShowActiveTab
  })), showActiveTab === 'audits' && /*#__PURE__*/React.createElement(Audits, _extends({}, getActionProps(actionItems['audits']), {
    setShow: setShowActiveTab
  })), showIframeUrl && /*#__PURE__*/React.createElement(ViewUrlLayer, {
    layer: showIframeUrl,
    closeLayer: () => setIframeUrl(false)
  })));
};
DashboardLayout.propTypes = {
  pathname: PropTypes.any,
  history: PropTypes.any,
  breadcrumbPath: PropTypes.any,
  heading: PropTypes.any,
  addTabBtn: PropTypes.any,
  panelPermissions: PropTypes.any,
  noDivider: PropTypes.bool,
  permissions: PropTypes.array,
  noSidebar: PropTypes.bool,
  noHeader: PropTypes.bool,
  footerLabel: PropTypes.any,
  noAlert: PropTypes.bool,
  component: PropTypes.any,
  tabs: PropTypes.array,
  childProps: PropTypes.object,
  noFooter: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['true', 'false'])]),
  fields: PropTypes.any,
  entityName: PropTypes.any,
  userEmail: PropTypes.string,
  componentMargin: PropTypes.bool,
  noTopNavbar: PropTypes.bool,
  shouldFetchHelpTexts: PropTypes.bool,
  shouldFetchPermissions: PropTypes.bool,
  navigationLayout: PropTypes.string
};
DashboardLayout.defaultProps = {
  componentMargin: true
};
const mapStateToProps = state => ({
  panelPermissions: PanelPermissionsDucks.getPanelPermissions(state)
});
export default connect(mapStateToProps)(DashboardLayout);